import { jsx, jsxs } from "react/jsx-runtime";
import {
  useRef,
  useState,
  useCallback,
  useEffect
} from "react";
import {
  DSDialog,
  DSDialogHeader,
  DSDialogBody,
  DSDialogFooter,
  DSDialogSeparator,
  DSDialogAddon
} from "@elliemae/ds-dialog";
import { useFocusTrap } from "@elliemae/ds-utilities";
import { DSButtonV2 } from "@elliemae/ds-button";
import { Close } from "@elliemae/ds-icons";
const useDecisionDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleDialog = useCallback(() => {
    setIsOpen((prev) => !prev);
  }, [setIsOpen]);
  return { isOpen, toggleDialog };
};
const DecisionDialog = ({
  isOpen,
  toggleDialog,
  children,
  onAffirmation,
  width = "425px",
  onClickOutside = () => {
  },
  affirmationButtonLabel = "Yes",
  denialButtonLabel = "No",
  showDenialButton = true,
  onClose = null
}) => {
  const firstElementRef = useRef(null);
  const lastElementRef = useRef(null);
  const handleOnKeyDown = useFocusTrap({
    firstElementRef,
    lastElementRef
  });
  useEffect(() => {
    const stopDialogPropagation = (e) => {
      if (e !== null && e.target instanceof HTMLElement) {
        if (e.target.dataset.portalbg) {
          e.stopPropagation();
          e.preventDefault();
        }
      }
    };
    document.getElementsByTagName("body")[0].addEventListener("click", stopDialogPropagation, true);
    return () => {
      document.getElementsByTagName("body")[0].removeEventListener("click", stopDialogPropagation, true);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    DSDialog,
    {
      isOpen,
      onClickOutside,
      onKeyDown: (e) => {
        handleOnKeyDown(e);
        e.stopPropagation();
      },
      width,
      children: [
        /* @__PURE__ */ jsx(DSDialogHeader, { pt: "0px", pb: "0px", children: /* @__PURE__ */ jsx(DSDialogAddon, { children: /* @__PURE__ */ jsx(
          DSButtonV2,
          {
            buttonType: "icon",
            onClick: onClose || toggleDialog,
            "aria-label": "close dialog",
            innerRef: firstElementRef,
            onKeyDown: () => {
            },
            children: /* @__PURE__ */ jsx(Close, { color: ["brand-primary", "800"] })
          }
        ) }) }),
        /* @__PURE__ */ jsx(DSDialogBody, { mt: "0px", pt: "0px", tabIndex: 0, children }),
        /* @__PURE__ */ jsx(DSDialogSeparator, {}),
        /* @__PURE__ */ jsxs(DSDialogFooter, { children: [
          showDenialButton && /* @__PURE__ */ jsx(
            DSButtonV2,
            {
              buttonType: "outline",
              onClick: toggleDialog,
              onKeyDown: () => {
              },
              children: denialButtonLabel
            }
          ),
          /* @__PURE__ */ jsx(
            DSButtonV2,
            {
              innerRef: lastElementRef,
              onClick: onAffirmation,
              onKeyDown: () => {
              },
              children: affirmationButtonLabel
            }
          )
        ] })
      ]
    }
  );
};
export {
  DecisionDialog,
  useDecisionDialog
};
